<template>
  <validation-provider
    #default="validationContext"
    :name="name"
    :vid="id"
    :rules="rules"
  >
    <b-form-group
      :label-for="id"
    >
      <template #label>

        <span
          class="text-primary"
          :class="{required:JSON.stringify(rules).includes('required')}"
        >
          {{ name }}
        </span>

      </template>
      <b-input-group
        class="shadow-none"
      >
        <b-input-group-prepend v-if="$slots.prependIcon">
          <b-input-group-text><slot name="prependIcon" /></b-input-group-text>
        </b-input-group-prepend>
        <b-form-input
          :id="id"
          v-model="tempText"
          class="custom-text-input"
          :placeholder="$attrs.placeholder || name"
          :state="getValidationState(validationContext)"
          :type="type"
          :disabled="disabled"
          @keyup.enter="$emit('enterPressed')"
        />
        <b-input-group-append
          v-if="$slots.appendIcon"
          class="shadow-none"
        >
          <b-input-group-text class="border-0">
            <slot name="appendIcon" />
          </b-input-group-text>
        </b-input-group-append>
      </b-input-group>
      <b-form-invalid-feedback
        :state="getValidationState(validationContext)"
      >
        {{ validationContext.errors[0] }}
      </b-form-invalid-feedback>
    </b-form-group>
  </validation-provider>
</template>
<script>
import formValidation from '@/@core/comp-functions/forms/form-validation'

export default {
  name: 'TextInput',
  props: {
    id: { type: String, default: '' },
    name: { type: String, default: '' },
    text: { type: [String, Number], default: '' },
    rules: { type: [String, Object], default: '' },
    type: { type: String, default: 'text' },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    tempText: {
      get() {
        return this.text
      },
      set(value) {
        this.$emit('update:text', value)
      },
    },
  },
  setup() {
    const { getValidationState } = formValidation()
    return { getValidationState }
  },
}
</script>
<style lang="">

</style>
